<div class="empty-state-container">
  <div
    class="d-flex flex-column justify-content-center align-items-center gap-2 align-self-stretch"
    [style.max-width.rem]="25">
    <div class="empty-state-title">{{ config.title }}</div>
    <div class="empty-state-description">{{ config.description }}</div>
    <div *ngIf="config.buttonText" class="mt-2">
      <app-primary-button (buttonClicked)="buttonClicked.emit()" [size]="BaseButtonSizeEnum.xs">{{
        config.buttonText
      }}</app-primary-button>
    </div>
  </div>
</div>
